import React, { Dispatch, SetStateAction } from 'react';
import { Breadcrumbs, ButtonBase, Typography, Box } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { PageLink } from '@/data/Navigation';
import {
	BreadcrumbLink,
	BreadcrumbMenuItem,
	BreadcrumbMenuItemLinkWrap,
} from '@/components/content/Header/parts/BreadcrumbMenuItem';
import {
	headerMobileBreadcrumbMenuIconSX,
	headerMobileBreadcrumbTypographyMainSX,
	headerMobileBreadcrumbBackContainerSX,
	headerMobileBreadcrumbsSX,
} from '@/components/content/Header/styles/mobileDrawer';

interface Props {
	items: PageLink[];
	path: PageLink[];
	onPathChange: Dispatch<SetStateAction<PageLink[]>>;
	onLabelChange: (label: string) => void;
}

export const BreadcrumbMenu: React.FC<Props> = ({ items, path, onPathChange, onLabelChange }) => {
	const handleClick = (category: PageLink) => () => {
		onPathChange((prev) => [...prev, category]);
		onLabelChange(category.label);
	};

	const handleBreadcrumbClick = (index: number) => {
		onPathChange((prev) => {
			const newPath = prev.slice(0, index + 1);

			if (newPath.length === 1) {
				return [];
			}

			return newPath;
		});
	};

	const handleBack = () => {
		onLabelChange('');
		if (path.length > 1) {
			handleBreadcrumbClick(path.length - 2);
			return;
		}
		onPathChange([]);
	};

	const currentCategory = path.length > 0 ? path[path.length - 1] : null;
	const lastCategory = path.at(-1);

	const data = currentCategory ? currentCategory.children : items;

	return (
		<Box>
			{path.length > 0 ? (
				<ButtonBase onClick={handleBack} sx={headerMobileBreadcrumbBackContainerSX}>
					<ArrowBackIosIcon sx={headerMobileBreadcrumbMenuIconSX} />
					<Typography variant="h6" sx={headerMobileBreadcrumbTypographyMainSX}>
						{'REGRESAR'}
					</Typography>
				</ButtonBase>
			) : null}
			<Breadcrumbs aria-label="breadcrumb" sx={headerMobileBreadcrumbsSX}>
				{path.map((category, index) => (
					<BreadcrumbLink
						url={category.url}
						key={index}
						label={category.label}
						onClick={() => handleBreadcrumbClick(index)}
					/>
				))}
			</Breadcrumbs>
			{data.map((item, index) => (
				<BreadcrumbMenuItem
					key={index}
					label={item.label}
					url={item.url}
					childrenPageLink={item.children}
					level={path.length}
					onClick={handleClick(item)}
				/>
			))}
			{lastCategory ? (
				<BreadcrumbMenuItemLinkWrap
					url={lastCategory.url}
					label={path.length === 1 ? `Ver todo ${lastCategory.label}` : 'Ver todo'}
				/>
			) : null}
		</Box>
	);
};
